import { coreThemeColors } from '@youscience/theme';
import { styled, Theme } from '@mui/material';

export const sxStyles = {
  tooltip: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',

    '> svg': {
      width: '20px',
      height: '20px',
      marginBottom: '-2px',
    },
  },
  infoItemDivider: {
    height: '26px',
    borderRight: `1px solid ${coreThemeColors.grey[300]}`,
  },
  flexPosition: {
    display: 'flex',
    alignItems: 'center',
  },
  infoItemTitle: {
    marginRight: '4px',
  },
  infoItemValue: (theme: Theme) => ({
    color: theme.palette.grey['600'],
    lineHeight: '1.5rem',
  }),
};

export const StyledContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const StyledFormHeader = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '1rem',
}));

export const StyledFormHeaderLeft = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
}));

export const StyledStatusBar = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '1rem',
}));
